import http from './client';

export interface IWheelInfo {
  giftId: number;
  giftRecieved: boolean;
}

async function getWheelInfo(): Promise<IWheelInfo> {
  const response = await http.get('/api/wheel/get');
  return response.data;
}

async function wheelSpin(): Promise<IWheelInfo> {
  const response = await http.post('/api/wheel/spin');
  return response.data;
}

const wheel = {
  getWheelInfo, wheelSpin
}

export default wheel;